import { render, staticRenderFns } from "./simOpenTnP.vue?vue&type=template&id=5397f7e6&scoped=true&"
import script from "./simOpenTnP.vue?vue&type=script&lang=js&"
export * from "./simOpenTnP.vue?vue&type=script&lang=js&"
import style0 from "./simOpenTnP.vue?vue&type=style&index=0&id=5397f7e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5397f7e6",
  null
  
)

export default component.exports